import React, { useCallback, useState } from "react"
import types from "prop-types"
import AddWhitelistedUserEmailDescButton from "./AddWhitelistedUserEmailDescButton"
import NewWhitelistedUserEmailDescForm from "./NewWhitelistedUserEmailDescForm"

const AddWhitelistedUserEmailDesc = ({ addWhitelistedUserEmailDesc, organization }) => {
  const { subdomain: organizationSubdomain } = organization

  const [showForm, setShowForm] = useState(false)

  const openForm = useCallback(() => setShowForm(true), [setShowForm])

  const closeForm = useCallback(() => setShowForm(false), [setShowForm])

  return (
    showForm
      ? (
        <NewWhitelistedUserEmailDescForm
          addWhitelistedUserEmailDesc={addWhitelistedUserEmailDesc}
          className="solution-container-dark"
          onCancel={closeForm}
          organizationSubdomain={organizationSubdomain}
        />
      )
      : <AddWhitelistedUserEmailDescButton onClick={openForm} />
  )
}

AddWhitelistedUserEmailDesc.propTypes = {
  addWhitelistedUserEmailDesc: types.func.isRequired,
  organization: types.object.isRequired,
}

export default AddWhitelistedUserEmailDesc
